"use client";

import { useState } from "react";
import { Download, Upload } from "lucide-react";
import { Button, Card, ErrorNote, Field, Select, Textarea } from "@/components/ui";
import { download } from "@/lib/utils";

export function SvgToPngTool() {
  const [kod, setKod] = useState("");
  const [genislik, setGenislik] = useState("512");
  const [beyazBg, setBeyazBg] = useState(false);
  const [hata, setHata] = useState("");
  const [calisiyor, setCalisiyor] = useState(false);

  const dosyaSec = (f: File | undefined) => {
    if (!f) return;
    f.text().then(setKod);
  };

  const donustur = async () => {
    setHata("");
    if (!kod.trim().startsWith("<svg")) {
      setHata("Geçerli bir SVG kodu girin veya dosya yükleyin.");
      return;
    }
    setCalisiyor(true);
    try {
      const w = Math.max(1, parseInt(genislik) || 512);
      const uri = `data:image/svg+xml;utf8,${encodeURIComponent(kod)}`;
      const img = new Image();
      await new Promise<void>((res, rej) => {
        img.onload = () => res();
        img.onerror = () => rej(new Error("SVG çizilemedi. Kodu kontrol edin."));
        img.src = uri;
      });
      const oran = img.naturalHeight && img.naturalWidth ? img.naturalHeight / img.naturalWidth : 1;
      const h = Math.round(w * oran);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d")!;
      if (beyazBg) {
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, w, h);
      }
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob((blob) => {
        if (!blob) return;
        download(blob, `gorsel-${w}px.png`);
      }, "image/png");
    } catch (e) {
      setHata(e instanceof Error ? e.message : "Dönüştürme başarısız.");
    } finally {
      setCalisiyor(false);
    }
  };

  return (
    <div className="space-y-4">
      <Card className="space-y-4">
        <label className="inline-flex cursor-pointer items-center gap-2 rounded-xl border border-border px-4 py-2.5 text-sm font-medium transition hover:bg-surface-muted">
          <Upload className="size-4" /> SVG dosyası yükle
          <input type="file" accept=".svg,image/svg+xml" hidden onChange={(e) => dosyaSec(e.target.files?.[0])} />
        </label>
        <Textarea value={kod} onChange={(e) => setKod(e.target.value)} rows={8} placeholder="…veya SVG kodunu buraya yapıştırın" className="font-mono text-xs" spellCheck={false} />
      </Card>

      <Card className="flex flex-wrap items-end gap-4">
        <Field label="PNG genişliği (px)">
          <Select value={genislik} onChange={(e) => setGenislik(e.target.value)} className="w-40">
            {["128", "256", "512", "1024", "2048"].map((v) => (
              <option key={v} value={v}>{v} px</option>
            ))}
          </Select>
        </Field>
        <label className="flex items-center gap-2 pb-3 text-sm">
          <input type="checkbox" checked={beyazBg} onChange={(e) => setBeyazBg(e.target.checked)} className="size-4 accent-[var(--brand)]" />
          Beyaz arka plan ekle
        </label>
        <Button onClick={donustur} loading={calisiyor} className="ml-auto">
          <Download className="size-4" /> PNG oluştur ve indir
        </Button>
      </Card>

      <ErrorNote>{hata}</ErrorNote>
      <p className="text-sm text-muted">Dönüştürme tamamen tarayıcınızda yapılır; dosyanız sunucuya gitmez.</p>
    </div>
  );
}
